import React from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import ProcedureTypeList from './ProcedureTypeList';

const ProcedureTypes = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Derechos de Agua', icon: 'icon-droplets' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Tipos de Trámite' links={breadcrumbLinks} icon={'icon-file-text'} />
					<ProcedureTypeList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ProcedureTypes;
